import Link from 'next/link';
import { Box, Typography } from '@mui/material';

interface LogoProps {
  iconSize?: number;
  fontSize?: string | object;
  /** Render only the logo mark (no wordmark, no home link) — e.g. as a page-header accent. */
  iconOnly?: boolean;
}

const LogoMark = ({ iconSize }: { iconSize: number }) => (
  <Box
    component="svg"
    width={iconSize}
    height={iconSize}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Porvenix logo icon"
    sx={{
      color: 'text.primary',
      flexShrink: 0,
    }}
  >
    <circle
      cx="16"
      cy="16"
      r="14"
      stroke="currentColor"
      strokeWidth="3"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="4"
      y1="16"
      x2="28"
      y2="16"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </Box>
);

export function Logo({ iconSize = 24, fontSize = '1.5rem', iconOnly = false }: LogoProps) {
  if (iconOnly) {
    return <LogoMark iconSize={iconSize} />;
  }

  return (
    <Link href="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: { xs: 0.75, sm: 1 },
          cursor: 'pointer',
          transition: 'opacity 0.2s ease',
          '&:hover': { opacity: 0.8 },
        }}
      >
        {/* Logo Icon - Circle with horizontal line */}
        <LogoMark iconSize={iconSize} />
        {/* Logo Text - PORVENIX */}
        <Typography
          variant="h6"
          sx={{
            fontWeight: 800,
            color: 'text.primary',
            fontSize: fontSize,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
          }}
        >
          PORVENIX
        </Typography>
      </Box>
    </Link>
  );
}

export default Logo;
